import moment from "moment";
import { formatNumber } from "../../../../services/utility/utils";
// import TickerLine from "../../../../components/CartTicket/components/CartConfirm/components/TickerLine";
import { ReactComponent as CoinValue } from "../../../../assets/images/icon-coin-bet.svg";
import "./styles.scss";
// import Round from "../../../../components/CartTicket/components/Round";
import { formatNumberForOdds, getRound } from "../../../../utils/utils";
import { useTheme } from "../../../../hook/useThemes";

export default function BetHistory({ entry }) {
  const betAbove = entry?.direction?.toLowerCase() === "moon";
  const odds = betAbove ? entry?.whitelabelMoonOdds : entry?.whitelabelRektOdds;
  const isAbove = entry?.livePrice < entry?.closePrice;
  const { lang } = useTheme();
  const isError =`${entry?.status}`.toLowerCase() === "refund";

  return (
    <div
      className={`bet-history 
      ${entry?.winning && "bet-won-history"}
    ${isError && "bet-history-error"}
    `}
    >
      <div className="wrap-column-round">
        <div className="wrap-round-id">
          <div className="round">
            {lang?.round || "Round"} #{getRound(entry?.contestLiveTime)}
          </div>
          <div className="id"> {entry?.contestId.substr(0, 8)} </div>
        </div>
        <div className="wrap-date-time">
          <div className="date">
            {moment(entry?.contestLiveTime).utc().format("DD/MM/YYYY")}
          </div>
          <div className="time">
            {moment(entry?.contestLiveTime).utc().format("HH:mm:ss")}{" "}
          </div>
        </div>
        {entry?.winning && (
          <div className="result">
            <CoinValue />
            {lang?.won || "WON!"}
          </div>
        )}
      </div>
      <div className="wrap-column-bet">
        <div className="row-value">
          <div className="label">{lang?.your_bet || "Your Bet"}:</div>
          <div className={`value value-bet-${betAbove ? "up" : "down"}`}>
            {betAbove
              ? lang[`up`]?.toUpperCase() || "UP"
              : lang[`down`]?.toUpperCase() || "DOWN"}
          </div>
        </div>
        <div className="row-value">
          <div className="label">{lang?.stake || "Stake"}:</div>
          <div className="value">
            ${formatNumberForOdds(entry?.wager, true)}
          </div>
        </div>
        <div className="row-value">
          <div className="label">{lang?.odds || "Odds"}:</div>
          <div className="value">{formatNumberForOdds(odds)}</div>
        </div>
        <div className="row-value">
          <div className="label">{lang?.locked_price || "Locked Price"}:</div>
          <div className="value">$ {formatNumber(entry?.livePrice, 2)}</div>
        </div>
        <div className="row-value">
          <div className="label">{lang?.final_price || "Final Price"}:</div>
          <div className={`value final-${isAbove ? "up" : "down"}`}>
            $ {formatNumber(entry?.closePrice, 2)}
          </div>
        </div>
        <div className="row-value">
          <div className="label">{lang?.payout || "Payout"}:</div>
          <div className={`value ${entry?.winning && "value-payout"}`}>
            ${" "}
            {entry?.winning
              ? formatNumberForOdds(entry?.whitelabelPayout)
              : "0.00"}
          </div>
        </div>

        {entry?.winning && (
          <div className="row-value-result">
            <CoinValue />
            WON !
          </div>
        )}
      </div>

      {isError && (
        <div className="content-history-error">
          <div className="content-error">
            <p
              className="label_error"
              dangerouslySetInnerHTML={{
                __html:
                  lang?.history_canceled ||
                  `Round cancelled.</br> All bets were refunded.`,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

{
  /* <div className="wrapper-round-history">
<Round
  content={`${lang?.round || "Round"} #${
    getRound(entry?.contestLiveTime) || ""
  }`}
/>
</div>
<div className="header">
<div className="title">
  <span>

    {moment(entry?.contestLiveTime).utc().format("DD/MM/YYYY HH:mm:ss")}
  </span>
  <span className="contest_id">
    {lang?.id || "ID"}: {entry?.contestId.substr(0, 8)}
  </span>
</div>
{entry?.winning ? (
  <div className="contest_status">{lang?.won || "WON!"}</div>
) : (
  ""
)}
</div>
<div className="body">
<div className={`contest_state`}>
  <div className="wrapper-row">
    <p className="row-title">{lang?.your_bet || "Your Bet"}:</p>
    <p className={`row-value ${betAbove ? "above" : "below"}`}>
      {lang?.close || "Close"}{" "}
      {betAbove
        ? lang[`above`]?.toLowerCase() || "Above"
        : lang[`below`]?.toLowerCase() || "Below"}
    </p>
  </div>
  <div className="wrapper-row">
    <p className="row-title">{lang?.your_stake || "Your Stake"}:</p>
    <p className="row-value">${entry?.wager}</p>
  </div>
  <div className="wrapper-row">
    <p className="row-title">{lang?.odds || "Odds"}:</p>
    <p className="row-value">{formatNumber(odds, 2)}</p>
  </div>
  <div className="ticker-line">
    <TickerLine
      valueDf={entry?.livePrice}
      coinValue={entry?.closePrice}
      isRandom={false}
      isShowLiveCoin={false}
    />
  </div>
</div>
<div className="bet_position">
  <div className="wrapper-row">
    <p className="row-title">{lang?.locked_price || "Locked Price"}:</p>
    <p className="row-value">${formatNumber(entry?.livePrice, 2)}</p>
  </div>
  <div className="wrapper-row">
    <p className="row-title">{lang?.results || "Result"}:</p>
    <p
      className={`row-value row-value-result ${
        isAbove ? "above" : "below"
      }`}
    >
      ${formatNumber(entry?.closePrice, 2)}
      <br></br>
      <span className="result-status">
        {isAbove
          ? lang?.up_by || "Up by "
          : lang?.down_by || "Down by "}{" "}
        {formatNumber(
          Math.abs(entry?.livePrice * 1 - entry?.closePrice * 1),
          2
        )}
      </span>
    </p>
  </div>

  {entry?.winning && (
    <div className="wrapper-row">
      <p className="row-title">{lang?.payout || "Payout"}:</p>
      <p className="row-value">
        ${formatNumber(entry?.whitelabelPayout)}
      </p>
    </div>
  )}
</div>
</div> */
}
